import React, { memo } from 'react'
import { ClientSecureWrapper } from 'src/components/layout/client/ClientSecureWrapper'
import { VaccinationForm } from 'src/components/client/vaccination-form/VaccinationForm'

const VaccinationPageComponent = () => {
  return (
    <ClientSecureWrapper>
      <VaccinationForm />
    </ClientSecureWrapper>
  )
}

export const VaccinationPage = memo(VaccinationPageComponent)
